import ApiService from "../../../../../shared/services/apiService"
import { API_ENDPOINT } from "../../../../../shared/types/enums"

export default class LinkedProfilesConfirmationService {

    static profileConfirmAsOBS = (_tenantId, _linkedProfileConfirmParams) => {
        return ApiService.postOBS(API_ENDPOINT.CORE, `/Profiles/LinkProfilesConfirmation/${_tenantId}`, JSON.stringify(_linkedProfileConfirmParams));
    }
}